<template>
  <div>
    <heading type="h2">
      {{ name }}
    </heading>
    <div class="adminBatch">
      <div class="panel panel-default">
        <div class="panel-heading">
          <a class="adminBatch__link" @click.prevent="expanded = !expanded" href>
            <i :class="`fa ${expandIconCss}`"></i>
            {{ batchId }}
          </a>
          <queue-nav :index="index" :name="name" :jobs="batches" :moveUp="parentMoveUp" :moveDown="parentMoveDown" :remove="parentRemove" />
        </div>
        <div v-for="queue in queues" :key="queue.name" class="adminBatch__panel panel-body" v-if="expanded">
          <div class="adminBatch__name">
            <span v-if="queue.psd">PSD </span>
            <span v-if="queue.html">HTML </span>
            {{ queue.name }}
          </div>
          <progress-bar :value="queue.progress" />
          <queue-nav :index="queue.priority" :name="queue.name" :jobs="queues" :moveUp="parentMoveUp" :moveDown="parentMoveDown" :remove="parentRemove"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'
import ProgressBar from '@/components/ProgressBar/progress-bar'
import QueueNav from './admin-queue-nav'
export default {
  name: 'AdminBatch',
  components: {
    QueueNav,
    Heading,
    ProgressBar
  },
  props: {
    name: String,
    batchId: String,
    html: Boolean,
    psd: Boolean,
    queues: Array,
    batches: Array,
    parentMoveUp: Function,
    parentMoveDown: Function,
    parentRemove: Function,
    index: Number
  },
  mounted () {},
  computed: {
    expandIconCss () {
      return this.expanded ? 'fa-minus-square' : 'fa-plus-square'
    }
  },
  data: () => ({
    expanded: true
  })
}
</script>

<style lang="scss">
    @import "./admin-batch";
</style>



// WEBPACK FOOTER //
// src/components/AdminBatch/admin-batch.vue